import { FormattedMessage } from "react-intl";
import { DownloadOptions } from "components/DownloadOptions/DownloadOptions";
import YouTube from 'react-youtube';

export const HeroBanner = () => {
	const opts = {
		width: "100%",
		height: "100%",
		playerVars: {
			autoplay: 1,
			controls: 1,
			mute: 1,
			modestbranding: 1,
			rel: 0,
		},
	};

	return (
		<section className="relative bg-gradient-to-b from-surface-50 to-white overflow-hidden">
			{/* Background decorations */}
			<div className="absolute inset-0 overflow-hidden">
				<div className="absolute top-0 left-1/4 w-96 h-96 bg-accent/5 rounded-full blur-3xl" />
				<div className="absolute bottom-0 right-1/4 w-96 h-96 bg-brand-100/50 rounded-full blur-3xl" />
			</div>

			{/* Content */}
			<div className="relative container-main pt-24 md:pt-28 lg:pt-32 pb-16 md:pb-20">
				<div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">

					{/* Text Content */}
					<div className="order-2 lg:order-1">
						{/* Badge */}
						<div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 border border-accent/20 rounded-full mb-6">
							<span className="relative flex h-2 w-2">
								<span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
								<span className="relative inline-flex rounded-full h-2 w-2 bg-accent"></span>
							</span>
							<span className="text-caption font-semibold text-accent uppercase tracking-wider">
								Disponible en Guatemala
							</span>
						</div>

						{/* Main Headline */}
						<h1 className="text-display-lg md:text-display-xl lg:text-display-2xl text-primary mb-6 leading-tight">
							Préstamos con{" "}
							<span className="text-gradient">Efektivos</span>
							{" "}rápidos y seguros
						</h1>

						{/* Description */}
						<p className="text-body-lg md:text-body-xl text-surface-600 mb-8 max-w-xl leading-relaxed">
							<FormattedMessage id="APP.HERO.BANNER.DESCRIPTION" />
						</p>

						{/* CTA Buttons */}
						<div className="flex flex-col sm:flex-row gap-4 mb-10">
							<DownloadOptions />
						</div>

						{/* Trust Indicators */}
						<div className="flex items-center gap-6 md:gap-8 p-4 md:p-6 bg-white rounded-2xl border border-surface-100 shadow-card">
							<div className="flex items-center gap-3">
								<div className="w-10 h-10 bg-accent/10 rounded-xl flex items-center justify-center">
									<svg className="w-5 h-5 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
									</svg>
								</div>
								<div>
									<div className="text-display-sm text-primary font-bold">50K+</div>
									<div className="text-caption text-surface-500">Usuarios</div>
								</div>
							</div>
							<div className="w-px h-12 bg-surface-200" />
							<div className="flex items-center gap-3">
								<div className="w-10 h-10 bg-yellow-100 rounded-xl flex items-center justify-center">
									<svg className="w-5 h-5 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
									</svg>
								</div>
								<div>
									<div className="text-display-sm text-primary font-bold">4.8</div>
									<div className="text-caption text-surface-500">Play Store</div>
								</div>
							</div>
							<div className="w-px h-12 bg-surface-200 hidden sm:block" />
							<div className="hidden sm:flex items-center gap-3">
								<div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center">
									<svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
									</svg>
								</div>
								<div>
									<div className="text-display-sm text-primary font-bold">24h</div>
									<div className="text-caption text-surface-500">Aprobación</div>
								</div>
							</div>
						</div>
					</div>

					{/* Video Content */}
					<div className="order-1 lg:order-2">
						<div className="relative">
							{/* Decorative elements */}
							<div className="absolute -top-8 -right-8 w-32 h-32 bg-accent/20 rounded-full blur-2xl" />
							<div className="absolute -bottom-8 -left-8 w-32 h-32 bg-brand-200/50 rounded-full blur-2xl" />

							{/* Video Container */}
							<div className="relative bg-white rounded-2xl overflow-hidden shadow-prominent border border-surface-100">
								<div className="aspect-video">
									<YouTube
										videoId="xVsCfsfB31Q"
										opts={opts}
										className="w-full h-full"
										iframeClassName="w-full h-full"
									/>
								</div>
							</div>

							{/* Floating Card - Left */}
							<div className="absolute -bottom-4 -left-4 bg-white rounded-xl shadow-elevated p-4 border border-surface-100 hidden md:block">
								<div className="flex items-center gap-3">
									<div className="w-12 h-12 bg-accent rounded-xl flex items-center justify-center">
										<svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
										</svg>
									</div>
									<div>
										<div className="text-body-sm font-bold text-primary">100% Digital</div>
										<div className="text-caption text-surface-500">Sin papeleos</div>
									</div>
								</div>
							</div>

							{/* Floating Card - Right */}
							<div className="absolute -top-4 -right-4 bg-white rounded-xl shadow-elevated p-3 border border-surface-100 hidden lg:block">
								<div className="flex items-center gap-2">
									<div className="flex -space-x-2">
										<div className="w-8 h-8 bg-accent/20 rounded-full flex items-center justify-center text-caption font-bold text-accent">+</div>
									</div>
									<div>
										<div className="text-caption font-bold text-primary">1,200+</div>
										<div className="text-caption text-surface-500">hoy</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
